import AppLink from '@chegg-wt/core/components/AppLink'
import { useDispatch } from 'react-redux'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { homepageCtaMapBannerText } from '@chegg-wt/core-wa/constants/paraphraser'
import {
  TextContainer,
  TextContentContainer,
  HeadingText,
  SubHeadingText,
  TextContent,
  TextContentHeading,
  TextHeadingContainer,
  HeadingButton,
  TextElement,
  HeadingIconContainer,
} from '../styled'
import { BannerTextProps } from './types'

const BannerText = ({
  subHeading,
  heading,
  textTheme,
  textContentHeadingFirst,
  textContentHeadingSecond,
  textContentHeadingThird,
  textContentFirst,
  textContentSecond,
  textContentThird,
  headingIcon,
  textIconFirst,
  textIconSecond,
  textIconThird,
  testId,
  redirect,
}: BannerTextProps): JSX.Element => {
  const dispatch = useDispatch()

  const handleHeadingButtonClick = (testId) => {
    dispatch(
      userClick({
        origin: origins.bannerTextGetStartedClick,
        name: homepageCtaMapBannerText[testId].name,
        region: homepageCtaMapBannerText[testId].region,
      })
    )
  }
  return (
    <TextContainer data-test={testId}>
      <TextHeadingContainer>
        <SubHeadingText textTheme={textTheme}>
          {headingIcon}
          <span>{subHeading}</span>
        </SubHeadingText>

        <HeadingText textTheme={textTheme}>{heading}</HeadingText>
        <AppLink route={redirect}>
          <HeadingButton
            textTheme={textTheme}
            href="#"
            onClick={() => handleHeadingButtonClick(testId)}
          >
            Get started
          </HeadingButton>
        </AppLink>
      </TextHeadingContainer>

      <TextContentContainer>
        <TextElement>
          <HeadingIconContainer>{textIconFirst}</HeadingIconContainer>
          <div>
            <TextContentHeading textTheme={textTheme}>
              {textContentHeadingFirst}
            </TextContentHeading>
            <TextContent textTheme={textTheme}>{textContentFirst}</TextContent>
          </div>
        </TextElement>

        <TextElement>
          <HeadingIconContainer> {textIconSecond}</HeadingIconContainer>
          <div>
            <TextContentHeading textTheme={textTheme}>
              {textContentHeadingSecond}
            </TextContentHeading>
            <TextContent textTheme={textTheme}>{textContentSecond}</TextContent>
          </div>
        </TextElement>

        {textContentHeadingThird && (
          <TextElement>
            <HeadingIconContainer>{textIconThird}</HeadingIconContainer>
            <div>
              <TextContentHeading textTheme={textTheme}>
                {textContentHeadingThird}
              </TextContentHeading>
              <TextContent textTheme={textTheme}>{textContentThird}</TextContent>
            </div>
          </TextElement>
        )}
      </TextContentContainer>
    </TextContainer>
  )
}

export default BannerText
